<template>
    <div>
        <SvgFilters />
        <HeroSection id="home" />
        <ResumeSection />
        <ProjectsSection />
        <AppFooter id="contact" />
    </div>
</template>

<script>
import SvgFilters from '@/components/effects/SvgFilters.vue';
import HeroSection from '@/components/hero/HeroSection.vue';
import ResumeSection from '@/components/resume/ResumeSection.vue';
import ProjectsSection from '@/components/projects/ProjectsSection.vue';
import AppFooter from '@/components/layout/AppFooter.vue';

export default {
    name: 'HomeView',
    components: { SvgFilters, HeroSection, ResumeSection, ProjectsSection, AppFooter },
};
</script>
